import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.188 14.375c-.52 0-1.012-.055-1.477-.219l-.902.903a.64.64 0 0 1-.465.191H10.25v1.094c0 .383-.3.656-.656.656H8.5v1.094c0 .383-.3.656-.656.656H5.656A.63.63 0 0 1 5 18.094v-2.188a.64.64 0 0 1 .191-.465l4.403-4.402c-.164-.465-.219-.957-.219-1.476a4.8 4.8 0 0 1 4.813-4.813A4.82 4.82 0 0 1 19 9.563c0 2.68-2.16 4.812-4.812 4.812m1.093-7c-.41 0-.765.219-.957.547a1.11 1.11 0 0 0 0 1.094c.192.355.547.547.957.547.383 0 .739-.192.93-.547a1.11 1.11 0 0 0 0-1.094 1.09 1.09 0 0 0-.93-.547"
    }, null, -1)
  ]))]))
}
export default { render: render }